/**
 * Auto Fleet Generator Module
 * 
 * Automatically generates optimized fleet configurations based on trip demand patterns
 * or manual service parameters. Ports functionality from Python shift_generator.py to TypeScript.
 * 
 * @module auto-fleet-generator
 */

// Core functionality (currently implemented)
export * from './timeUtils';
export * from './types';
export * from './tripAnalysis';
export * from './shiftGenerator';
export * from './timelineEditing';
export * from './tripLayerFleetGeneration';

// Main modal
export { default as AutoFleetGeneratorModal } from './AutoFleetGeneratorModal';

// Step components
export { default as ModeSelectionStep } from './ModeSelectionStep';
export { default as ConfigurationStep } from './ConfigurationStep';
export { default as PreviewStep } from './PreviewStep';

// Visualization components
export { default as FleetTimelineVisualization } from './FleetTimelineVisualization';
export { default as FleetSummaryCards } from './FleetSummaryCards';

